import { Alert } from './Alert';
import { AlertSeverity } from '@/constants/alertTypes';
import { AlertAnchorOrigin, parseAlertAnchorOrigin } from '@/constants/alertAnchorOrigin';
import { Snackbar as MuiSnackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import useToast from '@/hooks/use-toasts';

interface ToastProps {
  severity: AlertSeverity;
  id: string;
  text: string | null;
  duration: number | null;
  status: 'open' | 'closed';
  anchorOrigin: AlertAnchorOrigin;
}

export function Toast({ duration, id, severity, status, text, anchorOrigin }: ToastProps) {
  const { setToast, deleteToast } = useToast();
  const [open, setOpen] = useState(status === 'open');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setToast(id, {
      open: handleOpen,
      close: handleClose,
    });

    return () => deleteToast(id);
  }, [deleteToast, id, setToast]);

  return (
    <>
      <MuiSnackbar
        autoHideDuration={duration ?? 5000}
        open={open}
        onClose={handleClose}
        anchorOrigin={parseAlertAnchorOrigin(anchorOrigin)}
      >
        <Alert
          severity={severity}
          titleGutterBottom={false}
          text={text}
          onClose={handleClose}
          title={null}
        />
      </MuiSnackbar>
    </>
  );
}
